export interface CardType {
  cardId: string;
  cardName: string;
}
export interface PaymentToken {
  data: Data;
  iss: string;
  exp: number;
  type: string;
  iat: number;
  jti: string;
  content: Content;
}

export interface Content {
  paymentInformation: PaymentInformation;
  processingInformation?: {
    paymentSolution: {
      value: string;
    };
  };
}

export interface PaymentInformation {
  card: Card;
}

export interface Card {
  expirationYear: ExpirationYear;
  number: Number;
  expirationMonth: ExpirationYear;
  type: TypeValue;
}

export interface Number {
  maskedValue: string;
  bin: string;
}

export interface ExpirationYear {
  value: string;
}

export interface TypeValue {
  value: string;
}

export interface Data {
  expirationYear: string;
  number: string;
  expirationMonth: string;
  type: string;
}
export interface CardSummary {
  maskedCardNumber: string;
  expiration: string;
  cardType: string;
  cardName: string;
  isCreditCard: boolean;
}
export interface UCPaymentDetailResponse {
  status?: string;
  hasError: boolean;
  error?: Error;
  ucPaymentDetail?: UCPaymentDetailType;
}
export interface UCPaymentDetailType {
  paymentInformation?: {
    card: {
      expirationYear: string;
      number: string;
      expirationMonth: string;
      type: string;
    };
  };
  orderInformation?: {
    amountDetails: {
      totalAmount: string;
      currency: string;
    };
    billTo: {
      lastName: string;
      firstName: string;
      email?: string;
      address1: string;
      locality: string;
      administrativeArea: string;
      country: string;
      postalCode: string;
    };
    shipTo?: {
      lastName: string;
      firstName: string;
      email: string;
      address1: string;
      locality: string;
      administrativeArea: string;
      country: string;
      postalCode: string;
    };
  };
}
export interface UnifiedCheckoutContextPayload {
  targetOrigins: string[];
  country: string;
  locale: string;
  captureMandate: {
    billingType: string;
    requestEmail: boolean;
    requestPhone: boolean;
    requestShipping: boolean;
    shipToCountries?: string[];
    showAcceptedNetworkIcons: boolean;
  };
  orderInformation: {
    amountDetails: {
      totalAmount: string;
      currency: string;
    };
    billTo?: BillToInfo;
    shipTo?: {
      address1?: string;
      address2?: string;
      address3?: string;
      address4?: string;
      administrativeArea?: string;
      buildingNumber?: string;
      country?: string;
      district?: string;
      locality?: string;
      postalCode?: string;
      firstName?: string;
      lastName?: string;
    };
  };
  checkoutApiInitialization?: {
    profile_id?: string;
    access_key?: string;
    reference_number?: string;
    transaction_uuid?: string;
    transaction_type?: string;
    currency?: string;
    amount?: string;
    locale?: string;
    override_custom_receipt_page?: string;
    unsigned_field_names?: string;
  };
}

export interface BillToInfo {
  address1: string;
  address2?: string;
  address3?: string;
  address4?: string;
  administrativeArea: string;
  buildingNumber: string;
  country: string;
  district?: string;
  locality: string;
  postalCode: string;
  company?: {
    name?: string;
    address1?: string;
    address2?: string;
    address3?: string;
    address4?: string;
    administrativeArea?: string;
    buildingNumber?: string;
    country?: string;
    district?: string;
    locality?: string;
    postalCode?: string;
  };
  email?: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  nameSuffix?: string;
  title?: string;
  phoneNumber?: string;
  phoneType?: string;
}

export interface UnifiedCheckoutPaymentDetailPayload {
  transientToken: string;
}

export interface paymentSolutionType {
  value: string;
  type: string;
  text: string;
}

export const paymentSolutionTypes: paymentSolutionType[] = [
  {
    value: 'CC',
    type: 'CC',
    text: 'Credit Card',
  },
  {
    value: '001',
    type: 'APay',
    text: 'APay',
  },
  {
    value: '008',
    type: 'SPay',
    text: 'Samsung Pay',
  },
  {
    value: '012',
    type: 'GPay',
    text: 'GPay',
  },
  {
    value: '014',
    type: 'MCOF',
    text: 'Mastercard credential-on-file (COF)',
  },
  {
    value: '015',
    type: 'VCOF',
    text: 'Visa credential-on-file (COF)',
  },
  {
    value: 'visacheckout',
    type: 'VCP',
    text: 'Visa Click to Pay',
  },
];
